import { Types } from "../actions/SingleMaintenanceUpdateActions";

const initialState = {
    excelList: [],
    uploadExcelFileResponse: {},
};

export const SingleMaintenanceUpdate = (state = initialState, action) => {
    switch (action.type) {
        case Types.DOWNLOAD_SCHEMA:
            return {
                ...state,
            };
        case Types.DOWNLOAD_EXAMPLES:
            return {
                ...state,
            };
        case Types.UPLOAD_EXCEL:
            return {
                ...state,
            };
        case Types.EXCEL_TO_LIST_SINGLE_MAINTENANCE:
            return {
                ...state,
                excelList: action.payload || state.excelList,
            };
        case Types.UPLOAD_EXCEL_FILE_RESPONSE:
            return {
                ...state,
                uploadExcelFileResponse: action.payload || state.uploadExcelFileResponse,
            };
        default:
            return state;
    }
};
